'use strict';

// import debug from 'debug';
import { createApp, markRaw } from 'vue';
import { createPinia, PiniaPlugin, PiniaPluginContext } from 'pinia';
import 'chartjs-adapter-moment';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import '../scss/styles.scss';
import router from './router';
import i18n from '~/i18n';
import chartJs from './chart-js';

import photon from '~/plugins/photon/photon.plugins';
import prompt from '~/plugins/prompt.plugin';
import confirm from '~/plugins/confirm.plugin';
import eventBus from '~/plugins/mitt.plugins';
import errorHandler from '~/core/error-handler';
import notifier from '~/core/notifier';

import App from './app.vue';
import { AuthService } from './api/services/auth.service';
import { StationService } from './api/services/station.service';
import { HyperlocalService } from './api/services/hyperlocals.service';
import { WeatherService } from './api/services/weather.service';
import http from './api/api-http';
import { useConfigStore } from './store/configuration.store';

const app = createApp(App);

chartJs();

app.use(router);

app.use(prompt);
app.use(confirm);

app.use(photon);


const piniaPlugin: PiniaPlugin = (context: PiniaPluginContext) => {
    context.store.$authService = markRaw(AuthService.getInstance());
    context.store.$stationService = markRaw(StationService.getInstance());
    context.store.$hyperlocalService = markRaw(HyperlocalService.getInstance());
    context.store.$weatherService = markRaw(WeatherService.getInstance());
}

app.use(
    createPinia()
        .use(piniaPlugin)
        .use(({ store }) => {
            store.$router = markRaw(router);
        })
);

app.use(http)
app.use(i18n);
app.use(eventBus);
app.use(errorHandler);
app.use(notifier);

const configuration = useConfigStore();
if(!configuration.loaded) {
    configuration.load();
}

if(configuration?.environment !== 'dev') {
    Sentry.init({
        app,
        environment: configuration?.environment || 'dev',
        dsn: "https://3c4cde25052a4daabf8a118cb1d1b532@o4503998855970816.ingest.sentry.io/4504038618497024",
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["localhost", "my.elichens.com", "my-test.elichens.com", /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        release: configuration?.VERSION
    });
}


app.mount('#app');
